import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from 'src/app/signalr/notification.service';
import FeaUtils from '../FeaUtils';
import { FeaBaseProcessService } from './processes/fea-base-process.service';
import { ConditionResult } from '../models/results/condition-result';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeaConditionService {

  constructor(
    private readonly feaBaseProcessService : FeaBaseProcessService,
    private readonly http: HttpClient,
    public notificationService: NotificationService,
  ) {
  }

  public async getResult(mode: string) : Promise<any> {
    const baseRequest = await this.feaBaseProcessService.getBaseProcessRequest();
    const request = {
      ...baseRequest,
      ResultType: "Envelope",
      Mode: mode
    };

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
      }),
      responseType: 'json' as 'json'
    };

    try {
      const resultData = await firstValueFrom(this.http.post(environment.API_FEA + `Condition/GetResult`, request, options));
      const conditionResult = new ConditionResult(resultData);

      const csvText = await firstValueFrom(this.http.get(conditionResult.ResultUrl, { responseType: 'text' as 'text' }));
      var valuesPerElement = FeaUtils.ExtractValuesFromCSV(csvText);
      var title = mode == "Reliability" ? `Reliability: Probability of Failure` : `Code Checks Envelope`;
      return {
        valuesPerElement: valuesPerElement,
        title: title,
        processResult: conditionResult
      };
    }
    catch (err) {
      console.log(err);
      this.notificationService.addFailedNotification(`Failed to get or parse ${mode} Condition result`);
      return null; // Indicate failure
    }
  }
}
